import React from "react";
import './ProductSocial.scss'
import { Facebook, Globes, Linkedin, Twitter, Youtube } from "../../../../../../../assets/svg";

const socialData = [
    { id: 1, name: 'https://www.walacor.com/', iconname: 'globe', iconname2: <Globes /> },
    { id: 2, name: 'https://www.youtube.com/@walacor', iconname: 'youtube', iconname2: <Youtube /> },
    { id: 3, name: 'https://www.facebook.com/Walacor', iconname: 'facebook', iconname2: <Facebook />, tabbable: false },
    { id: 4, name: 'https://twitter.com/walacor', iconname: 'walacor', iconname2: <Twitter /> },
    { id: 5, name: 'https://linkedin.com/company/walacor', iconname: 'linkedin', iconname2: <Linkedin /> },
]
interface ISocialProps {

}


const SocialMediaLink = ({ socialData }) => {
    return (
        <div className="inner">
            {socialData.map((item, index) => (
                <div className="inner-wrapper" key={item.id}>
                    {item.tabbable === false ? (
                        // Facebook: show icon only, no focus / tab
                        <span aria-hidden="true">
                            {item.iconname2}
                        </span>
                    ) : (
                        <a target="_blank" rel="noopener noreferrer" href={item.name}>
                            <span>{item.iconname2}</span>
                        </a>
                    )}
                </div>
            ))}
        </div>
    );
};

function ProductSocial({ ...props }: ISocialProps) {
    return (
        <div className="social-card">
            <div className="title">Visit Walacor Online</div>
            <SocialMediaLink socialData={socialData} />
        </div>
    )
}

export default ProductSocial;